"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplePieChart = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var recharts_1 = require("recharts");
var BackGround_1 = require("../../BackGround");
var FieldFormatter_1 = require("../../FieldFormatter");
require("./simplePieChart.css");
var SimplePieChart = function (_a) {
    var width = _a.width, height = _a.height, data = _a.data, _b = _a.theme, theme = _b === void 0 ? 'default' : _b, tooltipFormatter = _a.tooltipFormatter, _c = _a.legendPosition, legendPosition = _c === void 0 ? {
        layoutDirection: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
    } : _c;
    var customTooltip = function (_a) {
        var active = _a.active, payload = _a.payload;
        if (active) {
            var cellInfo = payload[0].payload;
            return ((0, jsx_runtime_1.jsxs)(BackGround_1.BackGround, __assign({ color: "white", padding: "std", border: { style: 'all', type: 'light-grey' } }, { children: [cellInfo.label, ":", ' ', tooltipFormatter === 'money' ? (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Money, { amount: cellInfo.value }) : cellInfo.value, ' ', (0, function_1.pipe)(cellInfo.percentage, O.fromNullable, (0, Option_1.map)(function (p) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["(", (0, jsx_runtime_1.jsx)(FieldFormatter_1.FieldFormatter.Percentage, { amount: p, scale: 1 }), ")"] })); }), O.toNullable)] })));
        }
        return null;
    };
    return ((0, jsx_runtime_1.jsx)(recharts_1.ResponsiveContainer, __assign({ width: width, height: height, className: "pie-chart" }, { children: (0, jsx_runtime_1.jsxs)(recharts_1.PieChart, { children: [(0, jsx_runtime_1.jsx)(recharts_1.Pie, __assign({ data: data, cx: "50%", cy: "50%", dataKey: "value", nameKey: "label", stroke: "#FFF", strokeWidth: 1.5 }, (theme === 'default' ? {} : { innerRadius: 80 }), { outerRadius: 100, minAngle: 5 }, { children: data.map(function (entry, index) { return ((0, jsx_runtime_1.jsx)(recharts_1.Cell, { style: { outline: 'none' }, fill: entry.hexColor }, "cell-".concat(index))); }) })), (0, jsx_runtime_1.jsx)(recharts_1.Legend, { wrapperStyle: legendPosition.layoutDirection === 'vertical' ? { maxWidth: '40%' } : {}, layout: legendPosition.layoutDirection, verticalAlign: legendPosition.verticalAlign, align: legendPosition.align, iconType: "circle", iconSize: 10 }), (0, jsx_runtime_1.jsx)(recharts_1.Tooltip, { wrapperStyle: { outline: 'none' }, content: customTooltip })] }) })));
};
exports.SimplePieChart = SimplePieChart;
//# sourceMappingURL=SimplePieChart.js.map